import * as React from "react"
import { Route, Switch } from "react-router-dom"
import Landing from "./main"
import Block from "@bappweb/block"
import Image from "@bappweb/image"
import Element from "@bappweb/element"

const Layout = () => {
  return (
    <Block type="section" className="download-app" id="landing-page-wrapper">
      <Element type="h1" className="download-app-header">
        <span>Juzdan Uygulamasını İndir,</span>
        <span>Avantajları Kaçırma!</span>
      </Element>
      <Block className="download-app-container">
        <Block className="image">
          <Image path={"./img/juzdan/juzdan-app.jpg"} className="result-img" />
        </Block>
        <Switch>
          <Route exact path="/" component={Landing} />
        </Switch>
      </Block>
    </Block>
  )
}

export default Layout
